import SC from "./style";
import { useEffect, useState } from "react";
import { Button, Label } from "InnoUI/components";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { InputField } from "components";
import { apiGet, apiPost } from "api/callApi";
import { showAlert } from "utils/helper";
import { validateEmail, validtionMessages } from "utils/config";

const ExportPropertyModal = (props) => {
  const { setOpenModal, openModal, rowData, projectType } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [showpassword, setshowpassword] = useState(false);
  const [errorKeys, setErrorKeys] = useState({
    email: false,
  });

  const handleChange = (property, value) => {
    if (property === "email" || property === "secondaryEmail") {
      if (!validateEmail(value)) {
        setErrorKeys((prevKeys) => ({ ...prevKeys, [property]: true }));
      } else {
        setErrorKeys((prevKeys) => ({ ...prevKeys, [property]: false }));
      }
    }

    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!validateEmail(data?.email)) {
        setErrorKeys((prevKeys) => ({ ...prevKeys, email: true }));
        return;
      }
      // setshowpassword(true);
      // if (data?.password) {
      setLoading(true);
      const response = await apiPost("/v1/projects/exportrequest", {
        projectId: rowData.id,
        projectType: projectType,
        email: data.email,
        password: data.password, // assuming backend requires this
      });
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      setData({});
      setshowpassword(false);
      setOpenModal(false);
      // }
    } catch (error) {
      showAlert({
        title: "Error",
        text: error?.response?.data?.message || "An error occurred",
        icon: "error",
        button: "Try Again",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancelModal = () => {
    setOpenModal(false);
  };

  const AddModalData = () => {
    return (
      <form onSubmit={(e) => handleSubmit(e)}>
        <div
          style={{
            color: "red",
            alignContent: "center",
            justifyContent: "center",
            textAlign: "center",
            fontSize: "12px",
          }}
        >
          Caution: Project data will be shared through a download link sent to
          the provided email address. Please ensure email addresses are accurate
          before proceeding.
        </div>

        <div style={{ marginTop: "30px" }}>
          <Label label={"Email"}>
            <div
              style={{
                display: "flex",
                padding: "0px",
                flexDirection: "column",
              }}
            >
              <InputField
                name="email"
                value={data?.email}
                onChange={handleChange}
                type="email"
                required
                style={{ width: "100%" }}
              />
              {errorKeys.email && (
                <SC.ValidtionMessages>
                  {validtionMessages.email}
                </SC.ValidtionMessages>
              )}
            </div>
          </Label>
        </div>
        {/* {showpassword && (
          <div style={{ marginTop: "5px" }}>
            <Label label={"Password"}>
              <div
                style={{
                  display: "flex",
                  padding: "0px",
                  flexDirection: "column",
                }}
              >
                <InputField
                  name="password"
                  value={data?.password}
                  onChange={handleChange}
                  type="password"
                  required
                  style={{ width: "100%" }}
                />
              </div>
            </Label>
          </div>
        )} */}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            margin: "20px",
          }}
        >
          <Button
            caption="Cancel"
            onClick={handleCancelModal}
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.colors.cancelButton,
              color: theme.colors.white,
              minWidth: "90px",
              borderRadius: "3px",
              height: "30px",
              fontSize: "12px",
            }}
          />

          <Button
            caption={"Send"}
            isLoading={loading}
            type="submit"
            color="white"
            fontSize="12px"
            style={{
              marginBottom: 8,
              background: theme.gradient.themeGradient,
              color: theme.colors.white,
              minWidth: "90px",
              height: "30px",
              borderRadius: "3px",
            }}
          />
        </div>
      </form>
    );
  };

  return (
    <>
      {openModal && (
        <BulkActionView
          title={"Export Project"}
          openModal={openModal}
          renderBodyConditionally={AddModalData}
          handleCloseModal={() => {
            setOpenModal(false);
          }}
          sx={{
            minWidth: "550px",
          }}
        />
      )}
    </>
  );
};

export default ExportPropertyModal;
